/**
 * The medium a phone number capability covers. primary owns this vocabulary — a capability row
 * pairs a channel with a direction to describe one thing the number can do.
 *
 * `SMS` keeps its all-caps member name from primary's model rather than taking the repo's `Sms`
 * casing, so that moving the enum here stays a pure move; renaming it touches 67 call sites across
 * two apps and wants its own pass.
 */
export var PhoneNumberCapabilityChannel;
(function (PhoneNumberCapabilityChannel) {
    PhoneNumberCapabilityChannel["SMS"] = "SMS";
    PhoneNumberCapabilityChannel["Voice"] = "Voice";
})(PhoneNumberCapabilityChannel || (PhoneNumberCapabilityChannel = {}));
//# sourceMappingURL=channel.js.map